import { render, staticRenderFns } from "./diggingTreasure.vue?vue&type=template&id=29620e31&scoped=true&"
import script from "./diggingTreasure.vue?vue&type=script&lang=js&"
export * from "./diggingTreasure.vue?vue&type=script&lang=js&"
import style0 from "./diggingTreasure.vue?vue&type=style&index=0&id=29620e31&prod&lang=css&"
import style1 from "./diggingTreasure.vue?vue&type=style&index=1&id=29620e31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29620e31",
  null
  
)

export default component.exports